/* eslint-disable no-console */
/* eslint-disable no-plusplus */
function handleMainMenu() {
  const hamburger = document.querySelector('.menu-main-togglewrap .hamburger');
  const mainHeader = document.querySelector('.header-main');
  const topHeader = document.querySelector('.header-top');
  const mainMenu = document.querySelector('.menu-main__wrapper');
  const breakpoint = window.matchMedia('(min-width: 1350px)');

  // get body padding-top
  const bodyPaddingTop = window.getComputedStyle(document.body).getPropertyValue('padding-top');
  document.documentElement.style.setProperty('--body-padding-top', bodyPaddingTop);

  // get top header height
  const topHeaderHeight = topHeader ? topHeader.offsetHeight : 0;
  document.documentElement.style.setProperty('--top-header-height', `${topHeaderHeight}px`);

  hamburger?.addEventListener('click', () => {
    hamburger.classList.toggle('is-active');
    mainMenu.classList.toggle('is-open');
    mainHeader.classList.toggle('main-menu-open');
    document.body.classList.toggle('main-menu-open');
  });

  breakpoint.addEventListener('change', () => {
    if (breakpoint.matches === true) {
      hamburger?.classList.remove('is-active');
      mainMenu?.classList.remove('is-open');
      mainHeader?.classList.remove('main-menu-open');
      document.body.classList.remove('main-menu-open');
    }
  });
}

function closeActiveDropdown(target) {
  const btnActiveArrows = document.querySelectorAll('.header .btn-arrow-down');

  btnActiveArrows.forEach((button) => {
    if (!button.isEqualNode(target)) {
      button.classList.remove('active');

      const menuDropdown = button.closest('li');

      if (menuDropdown) {
        menuDropdown.querySelector('ul').classList.remove('active');
      }

      const countryDropdown = button.closest('.country-dropdown');

      if (countryDropdown) {
        countryDropdown.querySelector('.country-list').classList.remove('active');
      }
    }
  });
}

function handleMenuDropdown() {
  const btnArrows = document.querySelectorAll('li.has-children >.menu-link-wrap > .btn-arrow-down');

  if (!btnArrows) return;

  btnArrows.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const subMenu = btn.closest('li').querySelector('ul');

      closeActiveDropdown(btn);

      if (subMenu) {
        subMenu.classList.toggle('active');
        btn.classList.toggle('active');
      }
    });
  });
}

function regionDropdown() {
  const btnArrows = document.querySelectorAll('.header-top .country-dropdown .btn-arrow-down');
  if (!btnArrows.length > 0) return;

  btnArrows.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const countryList = btn.closest('.country-dropdown').querySelector('.country-list');
      closeActiveDropdown(btn);
      if (countryList) {
        countryList.classList.toggle('active');
        btn.classList.toggle('active');
      }
    });
  });
}

window.addEventListener('click', (e) => {
  closeActiveDropdown(e.target);
});

function handleMobileMenu() {
  const topMenuMobile = document.querySelector('#top-menu-mobile');
  const topMenu = document.querySelector('.header-top .menu');
  const applyOnline = document.querySelector('.menu-main >.menu-main__item:last-of-type a');
  const topBtnApply = document.querySelector('#btn-apply-online');

  if (topBtnApply && applyOnline) {
    const applyClone = applyOnline.cloneNode(true);
    topBtnApply.append(applyClone);
  }

  if (!topMenuMobile || !topMenu) return;

  const topMenuClone = topMenu.cloneNode(true);

  topMenuMobile.append(topMenuClone);
}

function initMainMenu(retryCount, delay) {
  const mainMenu = document.querySelector('.header .menu-main__wrapper');

  if (mainMenu) {
    console.log('Main menu found!');
    handleMobileMenu();
    handleMainMenu();
    handleMenuDropdown();

  } else if (retryCount < 5) {
    retryCount++;
    console.log(`Main menu not found, retrying (${retryCount}/5)...`);
    setTimeout(() => {
      initMainMenu(retryCount, delay);
    }, delay);
  } else {
    console.log('Main menu not found after maximum retries');
  }
}

window.addEventListener('DOMContentLoaded', () => {
  initMainMenu(0, 1000);
  regionDropdown();
});
